export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11065.3281d5a1.jpg";